// Generated by scripts/import-seo-content.js — do not edit by hand.
// Regenerate with: node scripts/import-seo-content.js

/** Public url and label per locale. A locale is absent until its copy is written. */
export type SeoLocalized = { sv: string, en?: string }

export type SeoPageEntry = {
  /** Public URL in each locale, e.g. /dack/transportbil/fiat-ducato and /tyres/van/fiat-ducato. */
  url: SeoLocalized
  /** Short label for navigation, e.g. "Dodge Ram" rather than "Däck till Dodge Ram". */
  navLabel: SeoLocalized
  /** True for the three category roots, which are search pages carrying SEO copy. */
  isRoot?: boolean
}

export const seoPages: SeoPageEntry[] = [
  {
    url: { sv: '/vara-varumarken', en: '/brands' },
    navLabel: { sv: 'Våra varumärken', en: 'Our brands' },
  },
  {
    url: { sv: '/vara-varumarken/dirt-at-wheels', en: '/brands/dirt-at-wheels' },
    navLabel: { sv: 'Dirt A.T Wheels' },
  },
  {
    url: { sv: '/vara-varumarken/boost-wheels', en: '/brands/boost-wheels' },
    navLabel: { sv: 'Boost Wheels' },
  },
  {
    url: { sv: '/vara-varumarken/blackbear', en: '/brands/blackbear' },
    navLabel: { sv: 'Blackbear' },
  },
  {
    url: { sv: '/vara-varumarken/ridgeblade', en: '/brands/ridgeblade' },
    navLabel: { sv: 'Ridgeblade' },
  },
  {
    url: { sv: '/dack', en: '/tyres' },
    navLabel: { sv: 'Däck', en: 'Tyres' },
    isRoot: true,
  },
  {
    url: { sv: '/dack/sommardack', en: '/tyres/summer-tyres' },
    navLabel: { sv: 'Sommardäck', en: 'Summer tyres' },
  },
  {
    url: { sv: '/dack/vinterdack', en: '/tyres/winter-tyres' },
    navLabel: { sv: 'Vinterdäck', en: 'Winter tyres' },
  },
  {
    url: { sv: '/dack/pickup', en: '/tyres/pickup' },
    navLabel: { sv: 'Pickup' },
  },
  {
    url: { sv: '/dack/pickup/dodge-ram', en: '/tyres/pickup/dodge-ram' },
    navLabel: { sv: 'Dodge Ram' },
  },
  {
    url: { sv: '/dack/pickup/chevrolet-silverado', en: '/tyres/pickup/chevrolet-silverado' },
    navLabel: { sv: 'Chevrolet Silverado' },
  },
  {
    url: { sv: '/dack/pickup/ford-f-150', en: '/tyres/pickup/ford-f-150' },
    navLabel: { sv: 'Ford F-150' },
  },
  {
    url: { sv: '/dack/pickup/ram-1500', en: '/tyres/pickup/ram-1500' },
    navLabel: { sv: 'Ram 1500' },
  },
  {
    url: { sv: '/dack/pickup/ford-ranger', en: '/tyres/pickup/ford-ranger' },
    navLabel: { sv: 'Ford Ranger' },
  },
  {
    url: { sv: '/dack/pickup/gmc-sierra', en: '/tyres/pickup/gmc-sierra' },
    navLabel: { sv: 'GMC Sierra' },
  },
  {
    url: { sv: '/dack/pickup/ram-rampage', en: '/tyres/pickup/ram-rampage' },
    navLabel: { sv: 'Ram Rampage' },
  },
  {
    url: { sv: '/dack/transportbil', en: '/tyres/van' },
    navLabel: { sv: 'Transportbil', en: 'Van' },
  },
  {
    url: { sv: '/dack/transportbil/mercedes-sprinter', en: '/tyres/van/mercedes-sprinter' },
    navLabel: { sv: 'Mercedes Sprinter' },
  },
  {
    url: { sv: '/dack/transportbil/volkswagen-transporter', en: '/tyres/van/volkswagen-transporter' },
    navLabel: { sv: 'Volkswagen Transporter' },
  },
  {
    url: { sv: '/dack/transportbil/ford-transit-custom', en: '/tyres/van/ford-transit-custom' },
    navLabel: { sv: 'Ford Transit Custom' },
  },
  {
    url: { sv: '/dack/transportbil/volkswagen-caddy', en: '/tyres/van/volkswagen-caddy' },
    navLabel: { sv: 'Volkswagen Caddy' },
  },
  {
    url: { sv: '/dack/transportbil/fiat-ducato', en: '/tyres/van/fiat-ducato' },
    navLabel: { sv: 'Fiat Ducato' },
  },
  {
    url: { sv: '/dack/transportbil/campervan', en: '/tyres/van/campervan' },
    navLabel: { sv: 'Campervan' },
  },
  {
    url: { sv: '/dack/transportbil/overlanding', en: '/tyres/van/overlanding' },
    navLabel: { sv: 'Overlanding' },
  },
  {
    url: { sv: '/dack/personbil', en: '/tyres/passenger-car' },
    navLabel: { sv: 'Personbil', en: 'Passenger car' },
  },
  {
    url: { sv: '/dack/faq', en: '/tyres/faq' },
    navLabel: { sv: 'FAQ' },
  },
  {
    url: { sv: '/falgar', en: '/rims' },
    navLabel: { sv: 'Fälgar', en: 'Rims' },
    isRoot: true,
  },
  {
    url: { sv: '/falgar/pickup', en: '/rims/pickup' },
    navLabel: { sv: 'Pickup' },
  },
  {
    url: { sv: '/falgar/pickup/dodge-ram', en: '/rims/pickup/dodge-ram' },
    navLabel: { sv: 'Dodge Ram' },
  },
  {
    url: { sv: '/falgar/pickup/ford-ranger', en: '/rims/pickup/ford-ranger' },
    navLabel: { sv: 'Ford Ranger' },
  },
  {
    url: { sv: '/falgar/pickup/chevrolet-silverado', en: '/rims/pickup/chevrolet-silverado' },
    navLabel: { sv: 'Chevrolet Silverado' },
  },
  {
    url: { sv: '/falgar/pickup/ford-f-150', en: '/rims/pickup/ford-f-150' },
    navLabel: { sv: 'Ford F-150' },
  },
  {
    url: { sv: '/falgar/pickup/ram-1500', en: '/rims/pickup/ram-1500' },
    navLabel: { sv: 'Ram 1500' },
  },
  {
    url: { sv: '/falgar/pickup/nissan-navara', en: '/rims/pickup/nissan-navara' },
    navLabel: { sv: 'Nissan Navara' },
  },
  {
    url: { sv: '/falgar/pickup/volkswagen-amarok', en: '/rims/pickup/volkswagen-amarok' },
    navLabel: { sv: 'Volkswagen Amarok' },
  },
  {
    url: { sv: '/falgar/pickup/gmc-sierra', en: '/rims/pickup/gmc-sierra' },
    navLabel: { sv: 'GMC Sierra' },
  },
  {
    url: { sv: '/falgar/pickup/ram-rampage', en: '/rims/pickup/ram-rampage' },
    navLabel: { sv: 'Ram Rampage' },
  },
  {
    url: { sv: '/falgar/transportbil', en: '/rims/van' },
    navLabel: { sv: 'Transportbil', en: 'Van' },
  },
  {
    url: { sv: '/falgar/transportbil/mercedes-sprinter', en: '/rims/van/mercedes-sprinter' },
    navLabel: { sv: 'Mercedes Sprinter' },
  },
  {
    url: { sv: '/falgar/transportbil/volkswagen-transporter', en: '/rims/van/volkswagen-transporter' },
    navLabel: { sv: 'Volkswagen Transporter' },
  },
  {
    url: { sv: '/falgar/transportbil/ford-transit-custom', en: '/rims/van/ford-transit-custom' },
    navLabel: { sv: 'Ford Transit Custom' },
  },
  {
    url: { sv: '/falgar/transportbil/volkswagen-caddy', en: '/rims/van/volkswagen-caddy' },
    navLabel: { sv: 'Volkswagen Caddy' },
  },
  {
    url: { sv: '/falgar/transportbil/fiat-ducato', en: '/rims/van/fiat-ducato' },
    navLabel: { sv: 'Fiat Ducato' },
  },
  {
    url: { sv: '/falgar/transportbil/campervan', en: '/rims/van/campervan' },
    navLabel: { sv: 'Campervan' },
  },
  {
    url: { sv: '/falgar/transportbil/overlanding', en: '/rims/van/overlanding' },
    navLabel: { sv: 'Overlanding' },
  },
  {
    url: { sv: '/falgar/personbil', en: '/rims/passenger-car' },
    navLabel: { sv: 'Personbil', en: 'Passenger car' },
  },
  {
    url: { sv: '/falgar/stalfalgar', en: '/rims/steel-wheels' },
    navLabel: { sv: 'Stålfälgar', en: 'Steel wheels' },
  },
  {
    url: { sv: '/falgar/aluminiumfalgar', en: '/rims/alloy-wheels' },
    navLabel: { sv: 'Aluminiumfälgar', en: 'Alloy wheels' },
  },
  {
    url: { sv: '/falgar/faq', en: '/rims/faq' },
    navLabel: { sv: 'FAQ' },
  },
  {
    url: { sv: '/kompletta-hjul', en: '/wheels' },
    navLabel: { sv: 'Kompletta hjul', en: 'Complete wheels' },
    isRoot: true,
  },
  {
    url: { sv: '/kompletta-hjul/pickup', en: '/wheels/pickup' },
    navLabel: { sv: 'Pickup' },
  },
  {
    url: { sv: '/kompletta-hjul/pickup/dodge-ram', en: '/wheels/pickup/dodge-ram' },
    navLabel: { sv: 'Dodge Ram' },
  },
  {
    url: { sv: '/kompletta-hjul/pickup/ford-ranger', en: '/wheels/pickup/ford-ranger' },
    navLabel: { sv: 'Ford Ranger' },
  },
  {
    url: { sv: '/kompletta-hjul/pickup/chevrolet-silverado', en: '/wheels/pickup/chevrolet-silverado' },
    navLabel: { sv: 'Chevrolet Silverado' },
  },
  {
    url: { sv: '/kompletta-hjul/pickup/ford-f-150', en: '/wheels/pickup/ford-f-150' },
    navLabel: { sv: 'Ford F-150' },
  },
  {
    url: { sv: '/kompletta-hjul/pickup/ram-1500', en: '/wheels/pickup/ram-1500' },
    navLabel: { sv: 'Ram 1500' },
  },
  {
    url: { sv: '/kompletta-hjul/pickup/nissan-navara', en: '/wheels/pickup/nissan-navara' },
    navLabel: { sv: 'Nissan Navara' },
  },
  {
    url: { sv: '/kompletta-hjul/pickup/volkswagen-amarok', en: '/wheels/pickup/volkswagen-amarok' },
    navLabel: { sv: 'Volkswagen Amarok' },
  },
  {
    url: { sv: '/kompletta-hjul/pickup/gmc-sierra', en: '/wheels/pickup/gmc-sierra' },
    navLabel: { sv: 'GMC Sierra' },
  },
  {
    url: { sv: '/kompletta-hjul/pickup/ram-rampage', en: '/wheels/pickup/ram-rampage' },
    navLabel: { sv: 'Ram Rampage' },
  },
  {
    url: { sv: '/kompletta-hjul/transportbil', en: '/wheels/van' },
    navLabel: { sv: 'Transportbil', en: 'Van' },
  },
  {
    url: { sv: '/kompletta-hjul/transportbil/mercedes-sprinter', en: '/wheels/van/mercedes-sprinter' },
    navLabel: { sv: 'Mercedes Sprinter' },
  },
  {
    url: { sv: '/kompletta-hjul/transportbil/volkswagen-transporter', en: '/wheels/van/volkswagen-transporter' },
    navLabel: { sv: 'Volkswagen Transporter' },
  },
  {
    url: { sv: '/kompletta-hjul/transportbil/ford-transit-custom', en: '/wheels/van/ford-transit-custom' },
    navLabel: { sv: 'Ford Transit Custom' },
  },
  {
    url: { sv: '/kompletta-hjul/transportbil/volkswagen-caddy', en: '/wheels/van/volkswagen-caddy' },
    navLabel: { sv: 'Volkswagen Caddy' },
  },
  {
    url: { sv: '/kompletta-hjul/transportbil/fiat-ducato', en: '/wheels/van/fiat-ducato' },
    navLabel: { sv: 'Fiat Ducato' },
  },
  {
    url: { sv: '/kompletta-hjul/transportbil/campervan', en: '/wheels/van/campervan' },
    navLabel: { sv: 'Campervan' },
  },
  {
    url: { sv: '/kompletta-hjul/transportbil/overlanding', en: '/wheels/van/overlanding' },
    navLabel: { sv: 'Overlanding' },
  },
  {
    url: { sv: '/kompletta-hjul/personbil', en: '/wheels/passenger-car' },
    navLabel: { sv: 'Personbil', en: 'Passenger car' },
  },
  {
    url: { sv: '/kompletta-hjul/faq', en: '/wheels/faq' },
    navLabel: { sv: 'FAQ' },
  },
]
